import React from "react";

const Logo = () => (
  <div className="flex items-center gap-3">
    <img
      src="https://customer-assets.emergentagent.com/job_bulk-supply-co/artifacts/6yi47sue_bks%20logo.png"
      alt="BKS"
      className="w-10 h-10 object-contain"
    />
    <span className="text-white tracking-[0.22em] text-sm font-medium">BKS WHOLESALE</span>
  </div>
);

export default function Header() {
  return (
    <header className="w-full py-6 px-6 md:px-10 flex justify-center relative z-20">
      <Logo />
    </header>
  );
}
